import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const kulturaService = {
    load,loadAll,save,remove,loadPreteklaSezona
    
};

function load(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/kultura/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(kultura => {
            // login successful if there's a jwt token in the response
            
            return kultura;
        });
}


function loadPreteklaSezona(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/kultura/preteklasezona/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(kultura => {
            // login successful if there's a jwt token in the response
            
            return kultura;
        });
}

function save(kultura) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(kultura)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/kultura`, requestOptions).then(handleResponse);
}


function remove(kultura) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(kultura)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/kultura`, requestOptions).then(handleResponse);
}

function loadAll(sezona){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/kultura/vsi/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(kultura => {
            // login successful if there's a jwt token in the response
            
            return kultura;
        });
}

